import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import { Delete as DeleteIcon, Cancel as CancelIcon } from '@mui/icons-material';

const DeleteConfirmDialog = ({ 
  open, 
  servicoNome, 
  onCancel, 
  onConfirm, 
  title = "Confirmar exclusão",
  message = "Esta ação excluirá permanentemente o serviço do sistema. Se houver senhas emitidas para este serviço, os registros históricos serão mantidos. Esta ação não pode ser desfeita."
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxWidth: 'sm',
          width: '100%'
        }
      }}
    >
      <DialogTitle sx={{ pt: 3, pb: 1 }}>
        {title}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <DeleteIcon color="error" sx={{ mr: 1, fontSize: '1.5rem' }} />
          <Typography variant="body1">
            Você está prestes a excluir {title.toLowerCase().includes('motivo') ? 'o motivo' : 'o serviço'} <strong>{servicoNome}</strong>.
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onCancel}
          color="inherit"
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          startIcon={<DeleteIcon />}
          sx={{ 
            '&:hover': {
              bgcolor: 'error.dark',
            }
          }}
        >
          Excluir
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmDialog; 